import { IRequestEventPdfSuccess } from '../../../actions/events/fetchEventPdf'
import { IEventsStore } from '../index'

export default function(
  state: IEventsStore,
  action: IRequestEventPdfSuccess,
): IEventsStore {
  return {
    ...state,
    pdf: action.pdf,
    pdfRequest: {
      ...state.pdfRequest,
      isLoading: false,
    },
  }
}
